import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";

export const StyledStatPaper = styled(Paper)(({ theme }) => ({
  padding: "20px",
  borderRadius: 8,
  cursor: "pointer",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledStatLabel = {
  color: "text.secondary",
  fontSize: "14px",
  fontWeight: 500,
} as const;

export const StyledStatValue = {
  color: "text.primary",
  fontSize: "28px",
  fontWeight: 700,
} as const;

export const StyledStatDetail = {
  color: "text.secondary",
  fontSize: "12px",
  fontWeight: 500,
  mt: 0.5,
} as const;
